import React from "react";

import styles from "./SlantedTag.module.css";


const SlantedTag = ({
	children,
	className = "",
	as = "div",
	unslantIcons = false,
	standardSpacing = false,
	...rest
}) => {
	const Component =
		as;

	const tagClassName =
		[
			className,
			styles.tag,

			standardSpacing
				? styles.standardSpacing
				: "",

			unslantIcons
				? styles.unslantIcons
				: "",
		]
			.filter(
				Boolean,
			)
			.join(
				" ",
			);


	return (
		<Component
			className={
				tagClassName
			}
			{...rest}
		>
			{children}
		</Component>
	);
};


export default SlantedTag;